export default __webpack_public_path__ + "92b4feb.png";